import React from 'react';
import '../Stylesheets/index.css';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import Loading from '../Components/Loading';

const Id = Loadable({
    loader: () => import('../Pages/g100s/_Id'),
    loading: Loading,
});
const Background = Loadable({
    loader: () => import('../Pages/g101s/Background'),
    loading: Loading,
});
const Main = Loadable({
    loader: () => import('../Pages/g100s/Main'),
    loading: Loading,
});
const Authors = Loadable({
    loader: () => import('../Pages/Authors'),
    loading: Loading,
});
const NotFound = Loadable({
    loader: () => import('../Pages/NotFound'),
    loading: Loading,
});
const Questions = Loadable({
    loader: () => import('../Pages/Questions'),
    loading: Loading,
});
const QuestionRedirect = Loadable({
    loader: () => import('../Pages/QuestionRedirect'),
    loading: Loading,
});
const Projects = Loadable({
    loader: () => import('../Pages/Projects'),
    loading: Loading,
});
const Trends = Loadable({
    loader: () => import('../Pages/Trends'),
    loading: Loading,
});
const Conferences = Loadable({
    loader: () => import('../Pages/Conferences'),
    loading: Loading,
});
const AuthorsPublications = Loadable({
    loader: () => import('../Pages/AuthorsPublications'),
    loading: Loading,
});
const Answers = Loadable({
    loader: () => import('../Pages/g100s/Answers'),
    loading: Loading,
});
const Researchers = Loadable({
    loader: () => import('../Pages/g100s/answers/Researchers'),
    loading: Loading,
});
const ResearchersNames = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Names'),
    loading: Loading,
});
const ResearchersDetails = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Details'),
    loading: Loading,
});
const ResearchersDetailsPreQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/details/DetailsPreQuestions'),
    loading: Loading,
});
const ResearchersDetailsQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/details/DetailsQuestions'),
    loading: Loading,
});
const ResearchersSpecialities = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Specialities'),
    loading: Loading,
});
const ResearchersSpecialitiesQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/specialities/SpecialitiesQuestions'),
    loading: Loading,
});
const ResearchersInfluences = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Influences'),
    loading: Loading,
});
const ResearchersInfluencesQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/influences/InfluencesQuestions'),
    loading: Loading,
});
const ResearchersContradictions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Contradictions'),
    loading: Loading,
});
const ResearchersContradictionsQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/contradictions/ContradictionsQuestions'),
    loading: Loading,
});
const ResearchersCollaborations = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Collaborations'),
    loading: Loading,
});
const ResearchersCollaborationsQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/collaborations/CollaborationsQuestions'),
    loading: Loading,
});
const ResearchersReasons = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/Reasons'),
    loading: Loading,
});
const ResearchersReasonsQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/researchers/reasons/ReasonsQuestions'),
    loading: Loading,
});
const Institutions = Loadable({
    loader: () => import('../Pages/g100s/answers/Institutions'),
    loading: Loading,
});
const InstitutionsNames = Loadable({
    loader: () => import('../Pages/g100s/answers/institutions/Names'),
    loading: Loading,
});
const InstitutionsProjects = Loadable({
    loader: () => import('../Pages/g100s/answers/institutions/Projects'),
    loading: Loading,
});
const InstitutionsProjectsQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/institutions/projects/ProjectsQuestions'),
    loading: Loading,
});
const Topics = Loadable({
    loader: () => import('../Pages/g100s/answers/Topics'),
    loading: Loading,
});
const TopicNames = Loadable({
    loader: () => import('../Pages/g100s/answers/topics/Names'),
    loading: Loading,
});
const TopicTrends = Loadable({
    loader: () => import('../Pages/g100s/answers/topics/Trends'),
    loading: Loading,
});
const TopicTrendsQuestions = Loadable({
    loader: () => import('../Pages/g100s/answers/topics/trends/TrendsQuestions'),
    loading: Loading,
});
const xTopics = Loadable({
    loader: () => import('../Pages/g100s/answers/Topics'),
    loading: Loading,
});
const Publishings = Loadable({
    loader: () => import('../Pages/g100s/answers/Publishings'),
    loading: Loading,
});
const sConferences = Loadable({
    loader: () => import('../Pages/g100s/answers/publishings/Conferences'),
    loading: Loading,
});
const sJournals = Loadable({
    loader: () => import('../Pages/g100s/answers/publishings/Journals'),
    loading: Loading,
});
const Done = Loadable({
    loader: () => import('../Pages/Done'),
    loading: Loading,
});
const ServerStructure = Loadable({
    loader: () => import('../Pages/ServerStructure'),
    loading: Loading,
});
const Import = Loadable({
    loader: () => import('../Components/Import'),
    loading: Loading,
});
const JSONImport = Loadable({
    loader: () => import('../Components/json/JSONImport'),
    loading: Loading,
});
const Export = Loadable({
    loader: () => import('../Components/Export'),
    loading: Loading,
});
const ImageExport = Loadable({
    loader: () => import('../Components/ImageExport'),
    loading: Loading,
});
const JSONExport = Loadable({
    loader: () => import('../Components/json/JSONExport'),
    loading: Loading,
});

function Body() {
    return (
        <div id="ApplicationBody">
            <Route component={Background} />
            <Switch>
                <Route exact path="/" component={Id} />
                <Route exact path="/main" component={Main} />
                <Route exact path="/answers" component={Answers} />
                <Route exact path="/answers/researchers" component={Researchers} />
                <Route exact path="/answers/researchers/names" component={ResearchersNames} />
                <Route exact path="/answers/researchers/details" component={ResearchersDetails} />
                <Route
                    exact
                    path="/answers/researchers/details/question/:no"
                    component={ResearchersDetailsPreQuestions}
                />
                <Route
                    exact
                    path="/answers/researchers/details/question/:no/:non"
                    component={ResearchersDetailsQuestions}
                />
                <Route
                    exact
                    path="/answers/researchers/specialities"
                    component={ResearchersSpecialities}
                />
                <Route
                    exact
                    path="/answers/researchers/specialities/question/:no"
                    component={ResearchersSpecialitiesQuestions}
                />
                <Route
                    exact
                    path="/answers/researchers/influences"
                    component={ResearchersInfluences}
                />
                <Route
                    exact
                    path="/answers/researchers/influences/question/:no"
                    component={ResearchersInfluencesQuestions}
                />
                <Route
                    exact
                    path="/answers/researchers/contradictions"
                    component={ResearchersContradictions}
                />
                <Route
                    exact
                    path="/answers/researchers/contradictions/question/:no"
                    component={ResearchersContradictionsQuestions}
                />
                <Route
                    exact
                    path="/answers/researchers/collaborations"
                    component={ResearchersCollaborations}
                />
                <Route
                    exact
                    path="/answers/researchers/collaborations/question/:no"
                    component={ResearchersCollaborationsQuestions}
                />
                <Route exact path="/answers/researchers/reasons" component={ResearchersReasons} />
                <Route
                    exact
                    path="/answers/researchers/reasons/question/:no"
                    component={ResearchersReasonsQuestions}
                />
                <Route exact path="/answers/institutions" component={Institutions} />
                <Route exact path="/answers/institutions/names" component={InstitutionsNames} />
                <Route
                    exact
                    path="/answers/institutions/projects"
                    component={InstitutionsProjects}
                />
                <Route
                    exact
                    path="/answers/institutions/projects/question/:no"
                    component={InstitutionsProjectsQuestions}
                />
                <Route exact path="/answers/topics" component={Topics} />
                <Route exact path="/answers/topics/names" component={TopicNames} />
                <Route exact path="/answers/topics/trends" component={TopicTrends} />
                <Route
                    exact
                    path="/answers/topics/trends/question/:no"
                    component={TopicTrendsQuestions}
                />
                <Route exact path="/answers/publishings" component={Publishings} />
                <Route exact path="/answers/publishings/conferences" component={sConferences} />
                <Route exact path="/answers/publishings/journals" component={sJournals} />
                <Route path="/research" component={Main} />
                <Route path="/authors" component={Authors} />
                <Route path="/topics" component={xTopics} />
                <Route path="/projects" component={Projects} />
                <Route path="/trends" component={Trends} />
                <Route path="/conferences" component={Conferences} />
                <Route path="/institutions" component={Institutions} />
                <Route path="/authorspublications" component={AuthorsPublications} />
                <Route path="/questions" component={Questions} />
                <Route path="/questionredirect" component={QuestionRedirect} />
                <Route path="/done" component={Done} />
                <Route path="/serverstructure" component={ServerStructure} />
                <Route exact path="/utils/import" component={Import} />
                <Route path="/utils/import/json" component={JSONImport} />
                <Route exact path="/utils/export" component={Export} />
                <Route path="/utils/export/png" component={ImageExport} />
                <Route path="/utils/export/json" component={JSONExport} />
                <Route component={NotFound} />
            </Switch>
        </div>
    );
}

export default Body;
